import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { ApiService } from '@services/api/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-directory-role-permissions',
  templateUrl: './user-directory-role-permissions.component.html',
  styleUrls: ['./user-directory-role-permissions.component.css']
})
export class UserDirectoryRolePermissionsComponent implements OnInit {
  public parent: any;
  private _entityId: any;
  public get entityId() { return this._entityId };
  public set entityId(value) {
    if (this._entityId == value)
      return;
    this._entityId = value;
    this.loadData();
  }
  directories: TreeNode[];
  loading: boolean = false;
  constructor(private apiService: ApiService, private route: ActivatedRoute) { }

  ngOnInit() {
    

    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }
    else {
      this.route.params.subscribe(params => {
        if (params.id) {
          this.entityId = params.id;
          this.loadData();
        }
      })
    }
  }
  public loadEntity() {
    this.loadData();
  }
  loadData() {
    this.loading = true;

    this.apiService.get(`/api/DirectoryStructure/detailedListForUser/${this.entityId}`)
      .subscribe(results => {
        this.directories = results;
        this.loading = false;
      }, err => {
        this.loading = false;
      });
  }

}
